import React, { useState } from "react";

import { FieldErrors, UseFormRegister } from "react-hook-form";
import styles from "./CheckboxButton.module.scss";
import block from 'bem-css-modules';
import { IFieldProperties } from "../InputFields.types";

import { sanitizeContent as s } from "../../../../util/functions";

const CheckboxButton = (props: { fieldData: IFieldProperties, register: UseFormRegister<any>, errors: FieldErrors }) => {
  const {
    fieldData: {
      title,
      label,
      text,
      validationText,
      settings: [{
        crmProperty,
        required,
      }]
    },
    register,
    errors
  } = props;

  const b = block(styles);

  const [checked, setChecked] = useState(false);

  return (
    <>
      {title && <h3>{title}</h3>}
      <div className={`${b("button")} ${checked && b("status-checked")}`}>
        <label htmlFor={label}>
          <span className={`${b("checkbox")} ${checked && b("is-checked")}`}>
            <input
              id={label}
              data-crm-field={crmProperty}
              type="checkbox"
              onClick={() => setChecked(!checked)}
              {...register(
                label,
                {
                  required: required
                }
              )}
            />
          </span>
          <span className={b("text")} dangerouslySetInnerHTML={{ __html: s(text) }} />
        </label>
        {errors[crmProperty] && (
          <div className={b("error")} dangerouslySetInnerHTML={{ __html: s(validationText) }} />
        )}
      </div>
    </>
  )
}

export default CheckboxButton;